import { useNavigate, useLocation, Link } from "react-router-dom";
import { useFormik } from "formik";
import { Button } from "reactstrap";
import { toast } from "react-toastify";

import axiosInstance from "../../../axiosInterceptor";
import { SwitchToggle } from "../../../helper/ImageFormat";
import Upload from "../../../Components/upload";
import { CollectionSchema } from "../../../Schema/Schema";

const AddCollection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const editingId = editData?.id;

  const initialValues = {
    position: editData?.position || editData?.nextPosition,
    name: editData?.name || "",
    url: editData?.url || "",
    image: editData?.image || null,
    isActive: editData?.isActive ?? true,
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormik({
    initialValues,
    validationSchema: CollectionSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const res = editingId
          ? await axiosInstance.put(`/collection/${editingId}`, values)
          : await axiosInstance.post("/collection", values);

        toast.success(res.data.message);
        navigate("/collections");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong");
      }
    },
  });

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5 mx-4">
        <h3 className="page-title">
          {editingId ? "Update" : "Add"} Collection
        </h3>
      </div>

      <div className="col-md-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">

                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Sort Order</label>
                    <input
                      type="number"
                      className={`form-control form-control-sm border border-dark ${
                        touched.position && errors.position ? "is-invalid" : ""
                      }`}
                      name="position"
                      placeholder="Enter sort order"
                      value={values.position}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.position && errors.position && (
                      <small className="text-danger">{errors.position}</small>
                    )}
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      className={`form-control form-control-sm border border-dark ${
                        touched.name && errors.name ? "is-invalid" : ""
                      }`}
                      name="name"
                      placeholder="Enter Name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.name && errors.name && (
                      <small className="text-danger">{errors.name}</small>
                    )}
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form-group">
                    <label>URL</label>
                    <input
                      type="text"
                      className="form-control form-control-sm border border-dark"
                      name="url"
                      placeholder="Enter URL"
                      value={values.url}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Collection Image (360 × 360)</label>
                    <Upload
                      label="image"
                      initialImage={values.image}
                      apiUrl="uploads?label=collection"
                      onChange={(file) => setFieldValue("image", file)}
                    />
                    {touched.image && errors.image && (
                      <small className="text-danger">{errors.image}</small>
                    )}
                  </div>
                </div>

                <div className="col-md-12 mt-4">
                  <SwitchToggle
                    checked={values.isActive}
                    onChange={(val) => setFieldValue("isActive", val)}
                  />
                </div>
              </div>

              <div className="text-center mt-4">
                <Button type="submit" color="primary" disabled={isSubmitting}>
                  {isSubmitting
                    ? editingId
                      ? "Updating..."
                      : "Submitting..."
                    : editingId
                    ? "Update"
                    : "Add"}
                </Button>

                <Link to="/collections">
                  <Button color="danger mx-2">Cancel</Button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCollection;
